<template>
  <div class="login-root">
    <!-- LEFT PANEL — Animated Scene -->
    <div class="scene-panel">
      <div class="scene-header">
        <div class="logo-mark">
          <svg
width="32"
height="32"
viewBox="0 0 32 32"
fill="none"
>
            <rect
width="32"
height="32"
rx="8"
fill="#fff"
fill-opacity="0.15"
/>
            <path
d="M8 22L12 10L16 18L20 13L24 22H8Z"
fill="white"
opacity="0.9"
/>
          </svg>
        </div>
        <span class="logo-name">GeoProc</span>
      </div>

      <!-- Floating stats -->
      <div class="stat-card stat-card--1">
        <div class="stat-icon">
📦
</div>
        <div>
          <div class="stat-value">
1,284
</div>
          <div class="stat-label">
Orders this month
</div>
        </div>
      </div>
      <div class="stat-card stat-card--2">
        <div class="stat-icon">
🚛
</div>
        <div>
          <div class="stat-value">
97.3%
</div>
          <div class="stat-label">
Delivery rate
</div>
        </div>
      </div>
      <div class="stat-card stat-card--3">
        <div class="stat-icon">
✅
</div>
        <div>
          <div class="stat-value">
342
</div>
          <div class="stat-label">
PO approved today
</div>
        </div>
      </div>

      <!-- Animated SVG illustration -->
      <div class="illustration">
        <svg
viewBox="0 0 480 340"
fill="none"
xmlns="http://www.w3.org/2000/svg"
class="scene-svg"
>

          <!-- Ground -->
          <rect
x="0"
y="290"
width="480"
height="4"
rx="2"
fill="white"
fill-opacity="0.15"
/>

          <!-- Warehouse building -->
          <rect
x="30"
y="160"
width="160"
height="130"
rx="4"
fill="white"
fill-opacity="0.1"
stroke="white"
stroke-opacity="0.2"
stroke-width="1.5"
/>
          <!-- Warehouse roof -->
          <polygon
points="20,160 110,120 200,160"
fill="white"
fill-opacity="0.15"
stroke="white"
stroke-opacity="0.25"
stroke-width="1.5"
/>
          <!-- Door -->
          <rect
x="80"
y="230"
width="60"
height="60"
rx="3"
fill="white"
fill-opacity="0.08"
stroke="white"
stroke-opacity="0.3"
stroke-width="1.5"
/>
          <!-- Windows -->
          <rect
x="45"
y="185"
width="30"
height="25"
rx="2"
fill="white"
fill-opacity="0.2"
/>
          <rect
x="145"
y="185"
width="30"
height="25"
rx="2"
fill="white"
fill-opacity="0.2"
/>
          <!-- Warehouse label -->
          <text
x="110"
y="215"
text-anchor="middle"
fill="white"
fill-opacity="0.5"
font-size="9"
font-family="monospace"
>WAREHOUSE</text>

          <!-- Conveyor belt -->
          <rect
x="195"
y="268"
width="120"
height="8"
rx="4"
fill="white"
fill-opacity="0.12"
stroke="white"
stroke-opacity="0.2"
stroke-width="1"
/>
          <!-- Belt rollers -->
          <circle
cx="200"
cy="272"
r="4"
fill="white"
fill-opacity="0.2"
/>
          <circle
cx="220"
cy="272"
r="4"
fill="white"
fill-opacity="0.2"
/>
          <circle
cx="240"
cy="272"
r="4"
fill="white"
fill-opacity="0.2"
/>
          <circle
cx="260"
cy="272"
r="4"
fill="white"
fill-opacity="0.2"
/>
          <circle
cx="280"
cy="272"
r="4"
fill="white"
fill-opacity="0.2"
/>
          <circle
cx="300"
cy="272"
r="4"
fill="white"
fill-opacity="0.2"
/>
          <circle
cx="310"
cy="272"
r="4"
fill="white"
fill-opacity="0.2"
/>

          <!-- Box 1 on conveyor (animated) -->
          <g class="box-slide">
            <rect
x="218"
y="248"
width="28"
height="22"
rx="2"
fill="white"
fill-opacity="0.25"
stroke="white"
stroke-opacity="0.5"
stroke-width="1.5"
/>
            <line
x1="218"
y1="259"
x2="246"
y2="259"
stroke="white"
stroke-opacity="0.4"
stroke-width="1"
/>
            <line
x1="232"
y1="248"
x2="232"
y2="270"
stroke="white"
stroke-opacity="0.4"
stroke-width="1"
/>
          </g>

          <!-- Truck body -->
          <g class="truck-drive">
            <!-- Cargo -->
            <rect
x="295"
y="212"
width="115"
height="65"
rx="3"
fill="white"
fill-opacity="0.14"
stroke="white"
stroke-opacity="0.3"
stroke-width="1.5"
/>
            <!-- Cab -->
            <rect
x="395"
y="228"
width="55"
height="49"
rx="4"
fill="white"
fill-opacity="0.2"
stroke="white"
stroke-opacity="0.35"
stroke-width="1.5"
/>
            <!-- Windshield -->
            <rect
x="403"
y="233"
width="32"
height="22"
rx="2"
fill="white"
fill-opacity="0.35"
/>
            <!-- Cab light -->
            <circle
cx="443"
cy="248"
r="4"
fill="#FFE082"
fill-opacity="0.9"
/>
            <!-- Undercarriage -->
            <rect
x="295"
y="274"
width="155"
height="12"
rx="2"
fill="white"
fill-opacity="0.08"
/>
            <!-- Wheels -->
            <circle
cx="330"
cy="284"
r="12"
fill="white"
fill-opacity="0.08"
stroke="white"
stroke-opacity="0.35"
stroke-width="2"
/>
            <circle
cx="330"
cy="284"
r="5"
fill="white"
fill-opacity="0.25"
/>
            <circle
cx="395"
cy="284"
r="12"
fill="white"
fill-opacity="0.08"
stroke="white"
stroke-opacity="0.35"
stroke-width="2"
/>
            <circle
cx="395"
cy="284"
r="5"
fill="white"
fill-opacity="0.25"
/>
            <circle
cx="435"
cy="284"
r="12"
fill="white"
fill-opacity="0.08"
stroke="white"
stroke-opacity="0.35"
stroke-width="2"
/>
            <circle
cx="435"
cy="284"
r="5"
fill="white"
fill-opacity="0.25"
/>
            <!-- Cargo boxes inside truck (visible through side) -->
            <rect
x="305"
y="230"
width="22"
height="20"
rx="1"
fill="white"
fill-opacity="0.15"
stroke="white"
stroke-opacity="0.3"
stroke-width="1"
/>
            <rect
x="332"
y="230"
width="22"
height="20"
rx="1"
fill="white"
fill-opacity="0.15"
stroke="white"
stroke-opacity="0.3"
stroke-width="1"
/>
            <rect
x="359"
y="230"
width="22"
height="20"
rx="1"
fill="white"
fill-opacity="0.15"
stroke="white"
stroke-opacity="0.3"
stroke-width="1"
/>
            <!-- Exhaust -->
            <rect
x="447"
y="218"
width="5"
height="14"
rx="2"
fill="white"
fill-opacity="0.2"
/>
          </g>

          <!-- Road dashes -->
          <g class="road-dash">
            <rect
x="60"
y="295"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.12"
/>
            <rect
x="110"
y="295"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.12"
/>
            <rect
x="160"
y="295"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.12"
/>
            <rect
x="210"
y="295"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.12"
/>
            <rect
x="260"
y="295"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.12"
/>
            <rect
x="310"
y="295"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.12"
/>
            <rect
x="360"
y="295"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.12"
/>
            <rect
x="410"
y="295"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.12"
/>
          </g>

          <!-- Floating document / PO card -->
          <g class="float-doc">
            <rect
x="30"
y="30"
width="90"
height="70"
rx="6"
fill="white"
fill-opacity="0.12"
stroke="white"
stroke-opacity="0.25"
stroke-width="1.5"
/>
            <text
x="45"
y="52"
fill="white"
fill-opacity="0.7"
font-size="7"
font-family="monospace"
font-weight="600"
>PURCHASE ORDER</text>
            <rect
x="40"
y="58"
width="55"
height="3"
rx="1"
fill="white"
fill-opacity="0.3"
/>
            <rect
x="40"
y="66"
width="40"
height="3"
rx="1"
fill="white"
fill-opacity="0.2"
/>
            <rect
x="40"
y="74"
width="50"
height="3"
rx="1"
fill="white"
fill-opacity="0.2"
/>
            <rect
x="40"
y="82"
width="30"
height="3"
rx="1"
fill="white"
fill-opacity="0.15"
/>
            <rect
x="58"
y="88"
width="32"
height="8"
rx="2"
fill="white"
fill-opacity="0.3"
/>
            <text
x="62"
y="95"
fill="white"
fill-opacity="0.8"
font-size="6"
font-family="monospace"
>APPROVED</text>
          </g>

          <!-- Network nodes / supply chain lines -->
          <g opacity="0.25">
            <line
x1="110"
y1="120"
x2="200"
y2="80"
stroke="white"
stroke-width="1"
stroke-dasharray="4 4"
/>
            <line
x1="200"
y1="80"
x2="310"
y2="100"
stroke="white"
stroke-width="1"
stroke-dasharray="4 4"
/>
            <line
x1="310"
y1="100"
x2="390"
y2="60"
stroke="white"
stroke-width="1"
stroke-dasharray="4 4"
/>
            <circle
cx="200"
cy="80"
r="4"
fill="white"
/>
            <circle
cx="310"
cy="100"
r="4"
fill="white"
/>
            <circle
cx="390"
cy="60"
r="4"
fill="white"
/>
            <circle
cx="110"
cy="120"
r="4"
fill="white"
/>
          </g>

          <!-- Ping animation on nodes -->
          <circle
cx="310"
cy="100"
r="4"
fill="white"
class="ping"
/>

        </svg>
      </div>

      <!-- Bottom tagline -->
      <div class="scene-footer">
        <p class="tagline">
Smarter procurement.<br>End-to-end visibility.
</p>
      </div>

      <!-- Background gradient orbs -->
      <div class="orb orb--1" />
      <div class="orb orb--2" />
    </div>

    <!-- RIGHT PANEL — Login Form -->
    <div class="form-panel">
      <div class="form-inner">
        <div class="form-logo">
          <b-img
:src="geolimLogo"
alt="Geolim Logo"
height="48"
width="48"
/>
        </div>
        <div class="form-eyebrow">
PT GEOSERVICES
</div>
        <h1 class="form-title">
Sign in
</h1>
        <p class="form-sub">
Access your procurement workspace
</p>

<validation-observer
  ref="loginForm"
  #default="{invalid}"
>
  <b-form
    class="login-form"
    @submit.prevent="login"
  >

    <b-form-group
      label="Username"
      label-for="login-email"
      class="field-group"
    >
      <validation-provider
        #default="{ errors }"
        name="Username"
        rules="required"
        tag="div"
      >
        <b-form-input
          id="login-email"
          ref="usernameInput"
          v-model="userUsername"
          :state="errors.length > 0 ? false : null"
          name="login-email"
          autocomplete="off"
          placeholder="your.username"
          class="custom-input"
          autofocus
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <b-form-group
      label="Password"
      label-for="login-password"
      class="field-group"
    >
      <validation-provider
        #default="{ errors }"
        name="Password"
        vid="password"
        rules="required"
        tag="div"
      >
        <b-input-group
          class="input-group-merge"
          :class="errors.length > 0 ? 'is-invalid' : null"
        >
          <b-form-input
            id="login-password"
            ref="passwordInput"
            v-model="password"
            :state="errors.length > 0 ? false : null"
            class="form-control-merge custom-input"
            :type="passwordFieldType"
            name="login-password"
            autocomplete="off"
            placeholder="••••••••"
          />
          <b-input-group-append is-text>
            <i
              class="cursor-pointer toggle-eye"
              :class="passwordFieldType === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"
              style="font-size: 1.1rem;"
              @click="togglePasswordVisibility"
            />
          </b-input-group-append>
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <div class="form-row-between">
      <b-form-checkbox
        id="remember-me"
        v-model="status"
        name="checkbox-1"
        class="custom-check"
      >
        Remember me
      </b-form-checkbox>
      <b-link
        :to="{name:'auth-forgot-password'}"
        class="forgot-link"
      >
        Forgot password?
      </b-link>
    </div>

    <b-button
      type="submit"
      block
      :disabled="invalid"
      class="signin-btn"
    >
      <span>Sign in</span>
      <feather-icon
        icon="ArrowRightIcon"
        size="16"
      />
    </b-button>

  </b-form>
</validation-observer>

        <p class="form-version">
GeoProc v2.0 &nbsp;·&nbsp; PT Geoservices
</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import axios from 'axios'
import moment from 'moment-timezone'
import { hmacSha256Hex } from '@/libs/hmacSha256'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userUsername: '',
      password: '',
      status: '',
      geolimLogo: require('@/assets/images/logo/geolim.png'),
      required,
      email,
      passwordFieldType: 'password',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'eye' : 'eye-off'
    },
  },
  mounted() {
    this.unlockLoginInputs()
  },
  activated() {
    this.unlockLoginInputs()
  },
  methods: {
    unlockLoginInputs() {
      this.$nextTick(() => {
        const inputs = [
          this.$refs.usernameInput,
          this.$refs.passwordInput,
        ].map(input => (input && input.$el ? input.$el : input)).filter(Boolean)

        inputs.forEach(input => {
          input.removeAttribute('readonly')
          input.removeAttribute('disabled')
          input.style.pointerEvents = 'auto'
        })

        if (inputs[0]) inputs[0].focus()
      })
    },
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (!success) return
        const payload = {
          username: this.userUsername,
          password: hmacSha256Hex(process.env.VUE_APP_KEY, this.password),
          time: moment(),
        }
        const headers = { 'Content-Type': 'application/json' }
        axios
          .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_LOGIN_URL}`, payload, { headers })
          .then(response => {
            if (response.data.success === true) {
              const Payload = response.data.data
              this.$cookies.set('userToken', Payload.accessToken.token)
              this.$cookies.set('userData', Payload.userData)
              this.$cookies.set('UserRole', Payload.userData.role.role_slug)
              this.$cookies.set('userBranch', Payload.Confirm)
              this.$cookies.set('userPermissions', Payload.userPermissions.join(','))
              this.$router.push({ name: 'dashboard' })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Notification',
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
              })
            }
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Notification',
                icon: 'BellIcon',
                variant: 'danger',
                text: 'Terjadi kesalahan',
              },
            })
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// ── Tokens ──────────────────────────────────────────────────────────
$accent:   #3B82F6;
$accent2:  #6366F1;
$dark:     #0F172A;
$darker:   #080E1C;
$surface:  #151E2E;
$border:   rgba(255,255,255,0.08);
$text-dim: rgba(255,255,255,0.45);

// ── Root layout ──────────────────────────────────────────────────────
.login-root {
  display: flex;
  min-height: 100vh;
  background: $darker;
  font-family: 'DM Sans', 'Segoe UI', sans-serif;
}

// ── LEFT — Scene panel ───────────────────────────────────────────────
.scene-panel {
  position: relative;
  flex: 1;
  display: none;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(135deg, #0F2855 0%, #0a1628 60%, #0d1f3c 100%);
  padding: 2.5rem;

  @media (min-width: 992px) { display: flex; }
}

.scene-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  z-index: 2;
}
.logo-name {
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

// Floating stat cards
.stat-card {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(255,255,255,0.07);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px;
  padding: 0.75rem 1rem;
  z-index: 3;
  animation: floatCard 6s ease-in-out infinite;

  .stat-icon { font-size: 1.4rem; }
  .stat-value { color: white; font-weight: 700; font-size: 1rem; line-height: 1.2; }
  .stat-label { color: $text-dim; font-size: 0.7rem; }

  &--1 { top: 18%;  left: 6%;   animation-delay: 0s;   }
  &--2 { top: 34%;  right: 8%;  animation-delay: 2s;   }
  &--3 { top: 52%;  left: 10%;  animation-delay: 4s;   }
}

@keyframes floatCard {
  0%, 100% { transform: translateY(0px); }
  50%       { transform: translateY(-8px); }
}

// Main SVG illustration
.illustration {
  position: absolute;
  bottom: 110px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 2;
}
.scene-svg {
  width: 100%;
  max-width: 520px;
}

// SVG animations
.truck-drive {
  animation: truckIdle 3s ease-in-out infinite;
}
@keyframes truckIdle {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-3px); }
}

.box-slide {
  animation: boxSlide 3s linear infinite;
}
@keyframes boxSlide {
  0%   { transform: translateX(0); }
  100% { transform: translateX(70px); opacity: 0; }
}

.float-doc {
  animation: floatDoc 5s ease-in-out infinite;
}
@keyframes floatDoc {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-10px); }
}

.ping {
  animation: ping 2s ease-out infinite;
  transform-origin: 310px 100px;
}
@keyframes ping {
  0%   { r: 4;  opacity: 0.9; }
  100% { r: 16; opacity: 0;   }
}

.road-dash {
  animation: dashMove 1.2s linear infinite;
}
@keyframes dashMove {
  from { transform: translateX(0); }
  to   { transform: translateX(-50px); }
}

// Background orbs
.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
}
.orb--1 {
  width: 360px; height: 360px;
  background: radial-gradient(circle, rgba(59,130,246,0.25) 0%, transparent 70%);
  top: -80px; left: -80px;
  animation: orbPulse 8s ease-in-out infinite;
}
.orb--2 {
  width: 280px; height: 280px;
  background: radial-gradient(circle, rgba(99,102,241,0.2) 0%, transparent 70%);
  bottom: 60px; right: -60px;
  animation: orbPulse 10s ease-in-out infinite reverse;
}
@keyframes orbPulse {
  0%, 100% { opacity: 0.7; transform: scale(1); }
  50%       { opacity: 1;   transform: scale(1.1); }
}

// Footer tagline
.scene-footer {
  position: absolute;
  bottom: 2.5rem;
  left: 2.5rem;
  z-index: 3;
}
.tagline {
  color: rgba(255,255,255,0.55);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  font-weight: 400;
}

// ── RIGHT — Form panel ───────────────────────────────────────────────
.form-panel {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $dark;
  padding: 2rem;

  @media (min-width: 992px) {
    width: 420px;
    flex-shrink: 0;
    border-left: 1px solid $border;
  }
}

.form-inner {
  width: 100%;
  max-width: 340px;
}

// Logo above form
.form-logo {
  margin-bottom: 1.25rem;
  img { border-radius: 10px; }
}

.form-eyebrow {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: $accent;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.form-title {
  color: white;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.35rem;
  line-height: 1.2;
}

.form-sub {
  color: $text-dim;
  font-size: 0.875rem;
  margin-bottom: 2.25rem;
}

// Field labels
.field-group {
  margin-bottom: 1.25rem;

  ::v-deep label {
    color: rgba(255,255,255,0.65);
    font-size: 0.78rem;
    font-weight: 500;
    letter-spacing: 0.03em;
    margin-bottom: 0.4rem;
  }
}

// Inputs
.custom-input {
  background: $surface !important;
  border: 1px solid $border !important;
  border-radius: 8px !important;
  color: white !important;
  padding: 0.65rem 0.85rem !important;
  font-size: 0.9rem !important;
  transition: border-color 0.2s, background-color 0.2s !important;

  &::placeholder { color: rgba(255,255,255,0.25) !important; }

  &:focus {
    border-color: $accent !important;
    box-shadow: none !important;
    background: $surface !important;
    transform: none !important;
  }
}

::v-deep .input-group-merge {
  border: 1px solid $border !important;
  border-radius: 8px !important;
  background: $surface !important;
  overflow: hidden;

  &:focus-within {
    border-color: $accent !important;
  }

  .form-control {
    border: 0 !important;
    border-radius: 8px 0 0 8px !important;
  }

  .input-group-append .input-group-text {
    background: $surface !important;
    border: 0 !important;
    border-radius: 0 8px 8px 0 !important;
    color: rgba(255,255,255,0.45) !important;

    svg { stroke: rgba(255,255,255,0.45) !important; }

    &:hover svg { stroke: rgba(255,255,255,0.8) !important; }
  }
}

.toggle-eye { color: #6e6b7b; transition: color 0.15s; &:hover { color: rgba(255,255,255,0.8); } }

// Row with checkbox + forgot
.form-row-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.75rem;
}

.custom-check {
  ::v-deep .custom-control-label {
    color: $text-dim;
    font-size: 0.82rem;
    cursor: pointer;
  }
  ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    background-color: $accent;
    border-color: $accent;
  }
}

.forgot-link {
  color: $accent;
  font-size: 0.82rem;
  text-decoration: none;
  &:hover { color: lighten(#3B82F6, 10%); }
}

// Sign in button
.signin-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, $accent 0%, $accent2 100%) !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 0.75rem !important;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  color: white !important;
  letter-spacing: 0.02em;
  transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s !important;
  box-shadow: 0 4px 20px rgba(59,130,246,0.35) !important;

  &:hover:not(:disabled) {
    opacity: 0.92;
    transform: translateY(-1px);
    box-shadow: 0 6px 28px rgba(59,130,246,0.45) !important;
  }
  &:active:not(:disabled) { transform: translateY(0); }
  &:disabled { opacity: 0.4 !important; }
}

// Version footer
.form-version {
  color: rgba(255,255,255,0.2);
  font-size: 0.7rem;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 0;
}
</style>
